<nz-drawer
  [nzVisible]="visible"
  nzPlacement="right"
  [nzMask]="false"
  [nzClosable]="false"
  [nzMaskClosable]="false"
  [nzTitle]="'page.vacation_management.drawer.title' | translate"
  (nzOnClose)="closeDrawer.emit(false)"
  [nzFooter]="drawerFooter"
  [formGroup]="form"
>
  <ng-container *nzDrawerContent>
    <div class="mb-2">
      <span nz-typography
        ><strong>{{
          'page.vacation.management.used_days' | translate
        }}</strong></span
      >
      <input
        nz-input
        [value]="hasMixed() ? '—' : computedFormattedUsedDays()"
        type="text"
        disabled
      />
    </div>

    <nz-divider class="my-3"></nz-divider>

    <div class="mb-2">
      <span nz-typography
        ><strong>{{
          'page.vacation_management.leave_days' | translate
        }}</strong></span
      >
      <wilson-input
        type="number"
        [placeholder]="
          hasMixed() ? ('component.mixed_placeholder' | translate) : ''
        "
        formControlName="leaveDays"
      />
    </div>
    <div class="mb-2">
      <span nz-typography
        ><strong>{{
          'page.vacation.management.special_leave_days' | translate
        }}</strong></span
      >
      <wilson-input
        type="number"
        [placeholder]="
          hasMixed() ? ('component.mixed_placeholder' | translate) : ''
        "
        formControlName="specialLeaveDays"
      />
    </div>

    <nz-divider class="my-3"></nz-divider>

    @if (shouldIncludeCarryover()) {
      <div class="mb-2">
        <span nz-typography>
          <strong>{{
            'page.vacation.management.carried_over_from_last_year' | translate
          }}</strong>
          <span
            nz-icon
            nzType="info-circle"
            nzTheme="outline"
            nz-tooltip
            [nzTooltipTitle]="carriedOverTooltip"
            class="ms-1 text-muted"
            style="cursor: help"
          ></span>
        </span>
        <input
          nz-input
          [value]="computedLocalizedCarryOverDays()"
          type="text"
          disabled
        />
      </div>
      <ng-template #carriedOverTooltip>
        <span>
          {{
            'page.vacation.management.carried_over_from_last_year.tooltip_prefix'
              | translate
          }}
          <a
            routerLink="/settings/company-settings"
            [queryParams]="{ tab: 'absences_settings' }"
          >
            {{
              'page.vacation.management.carried_over_from_last_year.tooltip_link'
                | translate
            }}
          </a>
        </span>
      </ng-template>
    }
    <div class="mb-2">
      <span nz-typography
        ><strong>{{
          'page.vacation.management.carried_over' | translate
        }}</strong></span
      >
      <wilson-input
        type="number"
        [placeholder]="
          hasMixed() ? ('component.mixed_placeholder' | translate) : ''
        "
        formControlName="carryoverDays"
      />
    </div>

    <nz-divider class="my-3"></nz-divider>

    <nz-statistic
      [nzValue]="hasMixed() ? '—' : computedBalance()"
      [nzTitle]="'page.vacation.management.balance' | translate"
    ></nz-statistic>
  </ng-container>
  <ng-template #drawerFooter>
    <div class="drawer__footer">
      <button
        data-test="cancel-button"
        nz-button
        class="w-100"
        nzType="default"
        (click)="closeDrawer.emit(false)"
      >
        {{ 'general.cancel' | translate }}
      </button>
      <button
        [disabled]="form.invalid || form.pristine"
        data-test="save-button"
        nz-button
        class="w-100"
        nzType="primary"
        (click)="saveVacations()"
      >
        {{ 'general.save' | translate }}
      </button>
    </div>
  </ng-template>
</nz-drawer>
